import { useMutation } from '@tanstack/react-query';
import { deleteTimeBlock } from '../../services/employee';

interface Options {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
  onMutate?: () => void;
  onSettled?: () => void;
}

function useDeleteTimeBlock({
  onSuccess,
  onError,
  onMutate,
  onSettled,
}: Options = {}) {
  return useMutation({
    mutationFn: ({
      resourceBlockId,
      employeeId,
    }: {
      resourceBlockId: number;
      employeeId: string;
    }) => deleteTimeBlock(resourceBlockId, employeeId),
    onSuccess,
    onError,
    onMutate,
    onSettled,
  });
}

export default useDeleteTimeBlock;
